'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("fixingService", function ($q, $http, indexationService, customIndexationService) {
  var getMarketHistory = function getMarketHistory(reference, options) {
    return $http.post("/rest/market/history/indexation", {
      reference: reference,
      options: _.extend(options || {}, {
        nbDonneeMax: 200
      })
    }).then(function (response) {
      return response.data.fixings;
    });
  };
  var _getSpreadHistory = function getSpreadHistory(ref1, ref2, options) {
    return $http.post("/rest/market/history/spread", {
      reference1: ref1,
      reference2: ref2,
      options: _.extend(options || {}, {
        nbDonneeMax: 200
      })
    }).then(function (response) {
      return response.data;
    });
  };
  var getMultipleMarketHistories = function getMultipleMarketHistories(references, options) {
    return $http.post("/rest/market/history/multiple-indexations", {
      references: references,
      options: _.extend(options || {}, {
        nbDonneeMax: 200
      })
    }).then(function (response) {
      return response.data;
    });
  };
  var indexToReference = function indexToReference(indexId) {
    return {
      type: "INDEX",
      indexId: indexId
    };
  };
  var _isValidReference = function isValidReference(reference) {
    if (reference == null) {
      return false;
    }
    switch (reference.type) {
      case "INDEX":
        {
          return reference.indexId != null;
        }
      case "CUSTOM_INDEXATION":
        {
          return reference.indexationId != null;
        }
      default:
        {
          return false;
        }
    }
  };

  /*
   * Pour les parametres "reference", voir la classe ReferenceValorisable
   * La référence est consistitué d'un type, et d'attributes d'identification.
   *
   * Ex : - { type : 'INDEX', indexId : 'myId' }
   *      - { type : 'CUSTOM_INDEXATION', indexationId : 'myId' }
   *
   * Les parametres possibles des options sont les suivants :
   *      - dateDebut
   *      - dateFin
   *      - nbDonneeMax
   * */
  return {
    isValidReference: function isValidReference(reference) {
      return _isValidReference(reference);
    },
    /**
     * Returns the label for given reference
     *
     * @param reference
     * @returns Promise<String>
     */
    getReferenceLabel: function getReferenceLabel(reference) {
      switch (reference.type) {
        case "INDEX":
          {
            return $q.when(indexationService.getIndice(reference.indexId)).then(function (indice) {
              return indice ? indice.label : "";
            });
          }
        case "CUSTOM_INDEXATION":
          {
            return $q.when(customIndexationService.getIndexation(reference.indexationId)).then(function (indexation) {
              return indexation ? indexation.name : "";
            });
          }
        default:
          {
            return $q.resolve("");
          }
      }
    },
    /**
     * Returns the market history for given valorisable reference.
     *
     * @param reference
     * @param options
     */
    getHistory: function getHistory(reference, options) {
      return getMarketHistory(reference, options);
    },
    /**
     * Returns the history for a spread between given valorisable references.
     *
     * @param ref1 reference of the first valorisable
     * @param ref2 reference of the second valorisable
     * @param options
     */
    getSpreadHistory: function getSpreadHistory(ref1, ref2, options) {
      return _getSpreadHistory(ref1, ref2, options);
    },
    /**
     * Returns the history for given index.
     * This is an alias to the getHistory method for indexes-only valorisables.
     *
     * @param index The id of the index to get history for.
     * @param options
     */
    getIndexHistory: function getIndexHistory(index, options) {
      return getMarketHistory(indexToReference(index), options);
    },
    getMultipleHistory: function getMultipleHistory(references, options) {
      return getMultipleMarketHistories(references, options);
    },
    getMonthlyFixings: function getMonthlyFixings(reference, month, year) {
      return $http.post("/rest/market/fixings/for-month", {
        reference: reference,
        month: month,
        year: year
      }).then(function (response) {
        return response.data;
      });
    },
    getMonthlySpreadFixings: function getMonthlySpreadFixings(reference1, reference2, month, year) {
      return $http.post("/rest/market/fixings/for-month", {
        reference1: reference1,
        reference2: reference2,
        month: month,
        year: year
      }).then(function (response) {
        return response.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/fixingService.js
// module id = 2872
// module chunks = 13